import { TypedDocumentNode } from 'apollo-angular';
import gql from 'graphql-tag';
import { IGqlFileEntitiesImport } from '../interfaces/file-import.interfaces';

export interface ICreateFileEntitesImportVariables {
	fileUrl: string;
	name: string;
}

export interface ICreateFileEntitiesImportResponse {
	createFileEntitiesImport: { fileEntitiesImport: IGqlFileEntitiesImport };
}

export interface IConfirmAllImportedFilesResponse {
	confirmAllImportedFiles: { success: boolean };
}

export interface IConfirmAllImportedFilesVariables {
	fileEntitiesImportPk: string;
}

export interface IDeleteFileEntitiesImportResponse {
	deleteFileEntitiesImports: { success: boolean };
}
export interface IRenameImportSession {
	editFileEntitiesImports: { success: boolean };
}

export interface IDeleteFileEntitiesResponse {
	deleteFiles: { success: boolean };
}

export interface IDeleteFileEntitiesVariables {
	files: string[];
}

export const createFileEntitiesImportMutation: TypedDocumentNode<
	ICreateFileEntitiesImportResponse,
	ICreateFileEntitesImportVariables
> = gql`
	mutation CreateFileEntitesImportMutation($fileUrl: String!, $name: String!) {
		createFileEntitiesImport(fileUrl: $fileUrl, name: $name) {
			fileEntitiesImport {
				id
				name
				pk
				status
				url
				zipUuid
			}
		}
	}
`;

export const updateFilesConfirmImportMutation = gql`
	mutation updateFiles($files: [UUID]!, $importConfirmed: Boolean) {
		updateFiles(files: $files, importConfirmed: $importConfirmed) {
			success
		}
	}
`;

export const confirmAllImportedFiles: TypedDocumentNode<
	IConfirmAllImportedFilesResponse,
	IConfirmAllImportedFilesVariables
> = gql`
	mutation ($fileEntitiesImportPk: UUID!) {
		confirmAllImportedFiles(fileEntitiesImportPk: $fileEntitiesImportPk) {
			success
		}
	}
`;

export const deleteFileEntitiesImportMutation: TypedDocumentNode<IDeleteFileEntitiesImportResponse> = gql`
	mutation DeleteFileEntitiesImports($pks: [UUID]!) {
		deleteFileEntitiesImports(pks: $pks) {
			success
		}
	}
`;

export const renameSessionMutation: TypedDocumentNode<IRenameImportSession> = gql`
	mutation EditFileEntitiesImports($updates: [EditFileEntitiesImportInput]!) {
		editFileEntitiesImports(updates: $updates) {
			success
		}
	}
`;

export const deleteFileEntitiesMutation: TypedDocumentNode<
	IDeleteFileEntitiesResponse,
	IDeleteFileEntitiesVariables
> = gql`
	mutation DeleteFileEntities($files: [UUID]!) {
		deleteFiles(files: $files) {
			success
		}
	}
`;
